// tanstack
import { createFileRoute } from '@tanstack/react-router';

// components
import CompressedAirBasic from '@/features/dashboards/layouts/compressed-air-basic/CompressedAirBasic';

export const Route = createFileRoute(
  '/$accountId/_user/dashboards/compressed-air',
)({
  component: CompressedAirBasic,
  staticData: { crumb: 'dashboards-compressed-air-basic:title' },
});
